import Image from 'next/image';
import { useRouter } from 'next/router';
import React, { useEffect, useRef, useState } from 'react';
import { FlowWelcome } from '../../assets/imageLibrary2';

import CollapsingSwipeableViews from '../../components/CollapsingSwipeableViews';
import { LoadSpecificService } from '../../DB/DB';

import Head from 'next/head';
import Marquee from 'react-fast-marquee';
import { RotatingLines } from 'react-loader-spinner';
import { toast } from 'react-toastify';
import {
  TickerIcon1,
  TickerIcon2,
  TickerIcon3,
  TickerIcon4,
  TickerIcon5,
} from '../../assets/icons';
import DiagnosisProgression from '../../components/Diagnosis/medical/DiagnosisProgression';
import SignInStep from '../../components/Diagnosis/signup/SignInStep';
import SignupFinalStep from '../../components/Diagnosis/signup/SignupFinalStep';
import SignUpFirstStep from '../../components/Diagnosis/signup/SignUpFirstStep';
import SignUpSecondStep from '../../components/Diagnosis/signup/SignUpSecondStep';
import { useDocContext } from '../../context/DocContext';
import { track } from '../../utils/funnelTracking';
import { VIEW_KEYS, EVENT_TYPES } from '../../utils/funnelConstants';

const TOTALSTEPS = 2;
function Diagnosis(props) {
  const router = useRouter();

  const { user } = useDocContext();

  // Subscription test: reached the sign-up step.
  useEffect(() => {
    track(VIEW_KEYS.SUB_SIGNUP, EVENT_TYPES.VIEWED);
  }, []);
  const swipeableRef = useRef(null);
  const containerRef = useRef();
  const [userLoaded, setuserLoaded] = useState(false);
  const [patientData, setPatientData] = useState({
    phase1: null,
    phase2: null,
  });

  const [currentStep, setcurrentStep] = useState(
    router?.query?.step != undefined ? router.query.step : 0
  );

  //   useEffect(() => {
  //     if (props.data == null || props?.data?.active == false) {
  //       // dont forget to set it to false
  //       const timeoutId = setTimeout(() => {
  //         toast.warning(
  //           'We currently do not treat this conditions, sorry for the inconvenience',
  //           { position: 'bottom-center' }
  //         );
  //         router.push('/services');
  //       }, 3000);

  //       return () => {
  //         // Clear the timeout if the props.data becomes available before the timeout fires.
  //         clearTimeout(timeoutId);
  //       };
  //     }
  //   }, [props.data, router]);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      localStorage.setItem('diseaseData', JSON.stringify(props.data));
    }
  }, [props.data]);
  useEffect(() => {
    setTimeout(() => {
      setuserLoaded(true);
    }, 1500);
  }, [user]);
  function updateHeight(e) {
    swipeableRef.current = e;
  }
  function changeIndex(index) {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }
  return (
    <div className='flowContainer'>
      <Head>
        <meta name='robots' content='noindex,nofollow' />
      </Head>
      <DiagnosisProgression
        TOTALSCREENS={2}
        current_step='Patient Info'
        currentScreen={currentStep}
      />
      {!userLoaded ? (
        <div className='flowWelcome spinnerContainer'>
          <RotatingLines
            visible={true}
            height='96'
            width='96'
            color='grey'
            strokeWidth='5'
            animationDuration='0.75'
            ariaLabel='rotating-lines-loading'
            wrapperStyle={{}}
            wrapperClass=''
          />
        </div>
      ) : (
        <div className='flowWelcome'>
          <CollapsingSwipeableViews index={currentStep} disabled>
            <div className='contentFlow'>
              <Image
                src={FlowWelcome}
                alt='Welcome image for new diagnosis'
                width={409}
                height={168}
              />

              <h2 className='flowHeading mt-4 mb-3'>
                Start your <br />
                <span>personal</span> consultation
              </h2>
              <p className='flowPara'>
                Let&apos;s check your medical info and symptoms, and then find
                treatments that fit your needs.
              </p>
              <button
                className='btnWelcome'
                onClick={() => setcurrentStep(currentStep + 1)}
              >
                Continue
              </button>
            </div>
            <SignUpFirstStep
              setcurrentStep={setcurrentStep}
              currentStep={currentStep}
              setPatientData={setPatientData}
              patientData={patientData}
            />
            <SignUpSecondStep
              setcurrentStep={setcurrentStep}
              currentStep={currentStep}
              setPatientData={setPatientData}
              patientData={patientData}
              diseaseID={props.data?.objectId}
              isSubscribing={true}
            />

            <SignupFinalStep
              setcurrentStep={setcurrentStep}
              currentStep={currentStep}
              patientData={{ ...patientData.phase1, ...patientData.phase2 }}
              isSubscribing={true}
            />
            <SignInStep
              setcurrentStep={setcurrentStep}
              currentStep={currentStep}
              isSubscribing={true}
            />
          </CollapsingSwipeableViews>
        </div>
      )}

      <Marquee className='marquee'>
        <p>
          <TickerIcon1 />
          No hidden fees
        </p>
        <p>
          <TickerIcon2 />
          Online care, anytime, anywhere
        </p>
        <p>
          <TickerIcon3 />
          No insurance? No problem!
        </p>
        <p>
          <TickerIcon4 />
          Secure medical records
        </p>
        <p>
          <TickerIcon5 />
          Personalized treatment plans
        </p>
      </Marquee>
    </div>
  );
}

export default Diagnosis;
// export async function getStaticProps(context) {
//   return { props: { layout: 'no-layout' } };
// }

export async function getServerSideProps(context) {
  const data = await LoadSpecificService(context.query.diseaseID);

  if (context.query.isUrgent)
    return { props: { data, isUrgent: context.query.isUrgent } };
  else return { props: { data, layout: 'no-layout' } };
}

export function getProgress(currentStep) {
  let progressRemaining = ((TOTALSTEPS - currentStep) / TOTALSTEPS) * 100;

  return 100 - progressRemaining;
}
